import { ISagaCb } from '@typings/requestPayloads'
import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ICancelMeetingRequestPayload extends ISagaCb {
    requestId: string
}

export interface ICancelMeetingRequestState {
    status: string
    data: any
    errors: any
}

const initialState: ICancelMeetingRequestState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const cancelMeetingRequest = createSlice({
    name: 'meeting-requests/cancel',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICancelMeetingRequestPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const cancelMeetingRequestActions = cancelMeetingRequest.actions
export default cancelMeetingRequest.reducer
